// [NEW FILE] Shown at the top of a form when useFormDraft() restored unsaved values.
import Banner from "./Banner";
import Button from "./Button";
import { formatDateTime } from "../../utils/format";

export default function DraftNotice({ draft, compact = false }) {
  if (draft?.restoredAt) {
    return (
      <div className="draft-notice">
      <Banner
        tone="info"
        title="Your unsaved changes were restored"
        action={<Button size="sm" variant="ghost" onClick={draft.discard}>Discard changes</Button>}
      >
        {compact
          ? `Saved on this device at ${formatDateTime(draft.restoredAt)}.`
          : `You left this form without saving (last change ${formatDateTime(draft.restoredAt)}). Check the values, then save.`}
      </Banner>
      </div>
    );
  }
  if (draft?.savedAt) {
    return <p className="draft-saved-note" role="status">Draft saved on this device</p>;
  }
  return null;
}
